module.exports = __webpack_public_path__ + "media/images/flags/gs-e1ffae80660e1ac3fc3851ff53fac932.svg";